import React, { PureComponent } from "react";

import { Alert } from "reactstrap";
import { ApiError } from "../api/request/ApiError";
import { GenericError } from "../redux/notifications/actions";

// Properties settable on the component
interface IPublicProps {
    error: GenericError;
    fieldLabelMap?: { [field: string]: string };
}

class UserError extends PureComponent<IPublicProps, {}> {

    public render() {
        const fieldMap = this.props.fieldLabelMap || {};

        if (!this.props.error)
            return false;

        if (typeof (this.props.error) === 'string') {
            return <Alert color="danger">{this.props.error} {this.props.children}</Alert>;
        }
        else if (!(this.props.error instanceof ApiError) || !this.props.error.isUserError) {
            return <Alert color="danger">{this.props.error.message || 'An error occurred'}{this.props.children}</Alert>;
        }
        else if (this.props.error.fieldErrors && this.props.error.fieldErrors.length > 0) {
            return (
                <Alert color="warning">
                    {this.props.error.message}
                    {this.props.error.fieldErrors && this.props.error.fieldErrors.length > 0 && this.props.error.fieldErrors[0].messages[0] !== this.props.error.message && (
                        <ul>
                            {this.props.error.fieldErrors.map((item, index) => (
                                <li key={index}>{fieldMap[item.field] || item.field}: {item.messages.map((msg, i2) => (<span key={i2}>{msg}</span>))}</li>
                            ))}
                        </ul>
                    )}
                    {this.props.children}
                </Alert>
            );
        }
        else {
            return (
                <Alert color="warning">
                    {this.props.error.message}
                    {this.props.children}
                </Alert>
            );
        }
    }
}

export default UserError;